/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateAreaRequestDto } from '../models';
// @ts-ignore
import type { DuplicatePoolRequestDto } from '../models';
// @ts-ignore
import type { GlobalPassUpdateRequestDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { PracticalExamQuestionItemDto } from '../models';
// @ts-ignore
import type { PracticalExamQuestionPoolDetailDto } from '../models';
// @ts-ignore
import type { PracticalExamQuestionPoolListResponseDto } from '../models';
// @ts-ignore
import type { PracticalExamQuestionPoolSummaryDto } from '../models';
// @ts-ignore
import type { PracticalExamQuestionPoolUploadResultDto } from '../models';
// @ts-ignore
import type { PracticalExamReportAttachmentDto } from '../models';
// @ts-ignore
import type { PracticalExamReportItemDto } from '../models';
// @ts-ignore
import type { PracticalExamSubquestionAttachmentDto } from '../models';
// @ts-ignore
import type { PracticalExamSubquestionItemDto } from '../models';
// @ts-ignore
import type { SetPracticalExamPoolActiveRequestDto } from '../models';
// @ts-ignore
import type { SetPracticalExamSubquestionActiveRequestDto } from '../models';
// @ts-ignore
import type { TimeLimitUpdateRequestDto } from '../models';
// @ts-ignore
import type { UpdateExamineeDescriptionRequestDto } from '../models';
// @ts-ignore
import type { UpsertSubquestionRequestDto } from '../models';
/**
 * PracticalExamQuestionPoolApi - axios parameter creator
 * @export
 */
export const PracticalExamQuestionPoolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Attach practical exam pool to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPracticalExamPoolToStage: async (certificationId: number, stageId: number, poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('attachPracticalExamPoolToStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('attachPracticalExamPoolToStage', 'stageId', stageId)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('attachPracticalExamPoolToStage', 'poolId', poolId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-question-pools/{poolId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dodaje nowy obszar (pytanie-obszar) do puli. Obszar pojawia się jako kolejna zakładka, do której można dodawać podkategorie (podpytania). 
         * @summary Create an area (question) in pool
         * @param {number} poolId 
         * @param {CreateAreaRequestDto} createAreaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamArea: async (poolId: number, createAreaRequestDto: CreateAreaRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('createPracticalExamArea', 'poolId', poolId)
            // verify required parameter 'createAreaRequestDto' is not null or undefined
            assertParamExists('createPracticalExamArea', 'createAreaRequestDto', createAreaRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/areas`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAreaRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dodaje podpytanie do pytania (obszaru). Opcjonalnie przypisuje do raportu (gdy subquestion jest pytaniem do raportu, nie do obszaru-pytania). 
         * @summary Create a subquestion in pool
         * @param {number} poolId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamSubquestion: async (poolId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('createPracticalExamSubquestion', 'poolId', poolId)
            // verify required parameter 'upsertSubquestionRequestDto' is not null or undefined
            assertParamExists('createPracticalExamSubquestion', 'upsertSubquestionRequestDto', upsertSubquestionRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSubquestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a practical exam report (cascades to attachments + S3 objects)
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamReport: async (poolId: number, reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('deletePracticalExamReport', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deletePracticalExamReport', 'reportId', reportId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a PDF attachment from a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamReportAttachment: async (poolId: number, reportId: number, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('deletePracticalExamReportAttachment', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deletePracticalExamReportAttachment', 'reportId', reportId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deletePracticalExamReportAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}/attachments/{attachmentId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a whole category (section) — all subquestions with the given area and sectionTitle
         * @param {number} poolId 
         * @param {string} area 
         * @param {string} sectionTitle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSection: async (poolId: number, area: string, sectionTitle: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('deletePracticalExamSection', 'poolId', poolId)
            // verify required parameter 'area' is not null or undefined
            assertParamExists('deletePracticalExamSection', 'area', area)
            // verify required parameter 'sectionTitle' is not null or undefined
            assertParamExists('deletePracticalExamSection', 'sectionTitle', sectionTitle)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/sections`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (sectionTitle !== undefined) {
                localVarQueryParameter['sectionTitle'] = sectionTitle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSubquestion: async (poolId: number, subquestionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('deletePracticalExamSubquestion', 'poolId', poolId)
            // verify required parameter 'subquestionId' is not null or undefined
            assertParamExists('deletePracticalExamSubquestion', 'subquestionId', subquestionId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions/{subquestionId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"subquestionId"}}`, encodeURIComponent(String(subquestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a PDF attachment from a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSubquestionAttachment: async (poolId: number, subquestionId: number, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('deletePracticalExamSubquestionAttachment', 'poolId', poolId)
            // verify required parameter 'subquestionId' is not null or undefined
            assertParamExists('deletePracticalExamSubquestionAttachment', 'subquestionId', subquestionId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deletePracticalExamSubquestionAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions/{subquestionId}/attachments/{attachmentId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"subquestionId"}}`, encodeURIComponent(String(subquestionId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detach practical exam pool from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPracticalExamPoolFromStage: async (certificationId: number, stageId: number, poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('detachPracticalExamPoolFromStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('detachPracticalExamPoolFromStage', 'stageId', stageId)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('detachPracticalExamPoolFromStage', 'poolId', poolId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-question-pools/{poolId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tworzy nową pulę pytań jako głęboką kopię istniejącej (questions, subquestions, reports, załączniki — same metadane, pliki S3 nie są kopiowane fizycznie; klonowane są same referencje). Wynikowa pula jest tworzona z `active=false` i pustym powiązaniem ze stage. 
         * @summary Duplicate an existing practical exam question pool
         * @param {number} poolId 
         * @param {DuplicatePoolRequestDto} duplicatePoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePracticalExamQuestionPool: async (poolId: number, duplicatePoolRequestDto: DuplicatePoolRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('duplicatePracticalExamQuestionPool', 'poolId', poolId)
            // verify required parameter 'duplicatePoolRequestDto' is not null or undefined
            assertParamExists('duplicatePracticalExamQuestionPool', 'duplicatePoolRequestDto', duplicatePoolRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/duplicate`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicatePoolRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practical exam pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamQuestionPoolDetail: async (poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getPracticalExamQuestionPoolDetail', 'poolId', poolId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practical exam report detail with attachments
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamReportDetail: async (poolId: number, reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getPracticalExamReportDetail', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getPracticalExamReportDetail', 'reportId', reportId)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practical exam pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStagePracticalExamQuestionPools: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getStagePracticalExamQuestionPools', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getStagePracticalExamQuestionPools', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-question-pools`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List practical exam question pools
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ListPracticalExamQuestionPoolsSortByEnum} [sortBy] 
         * @param {ListPracticalExamQuestionPoolsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPracticalExamQuestionPools: async (page?: number, pageSize?: number, search?: string, sortBy?: ListPracticalExamQuestionPoolsSortByEnum, sortDirection?: ListPracticalExamQuestionPoolsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/practical-exam-question-pools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggles whether the pool is active. Inactive pools are excluded from question drawing for newly generated exams; existing exams keep their questions. 
         * @summary Set practical exam question pool active flag
         * @param {number} poolId 
         * @param {SetPracticalExamPoolActiveRequestDto} setPracticalExamPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPracticalExamQuestionPoolActive: async (poolId: number, setPracticalExamPoolActiveRequestDto: SetPracticalExamPoolActiveRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('setPracticalExamQuestionPoolActive', 'poolId', poolId)
            // verify required parameter 'setPracticalExamPoolActiveRequestDto' is not null or undefined
            assertParamExists('setPracticalExamQuestionPoolActive', 'setPracticalExamPoolActiveRequestDto', setPracticalExamPoolActiveRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/active`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPracticalExamPoolActiveRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Przełącza flagę `active` podpytania (podkategorii). Nieaktywne podpytania nie są losowane do nowo generowanych egzaminów; istniejące wyniki egzaminów pozostają nietknięte. 
         * @summary Toggle subquestion active flag (soft delete / restore)
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {SetPracticalExamSubquestionActiveRequestDto} setPracticalExamSubquestionActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPracticalExamSubquestionActive: async (poolId: number, subquestionId: number, setPracticalExamSubquestionActiveRequestDto: SetPracticalExamSubquestionActiveRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('setPracticalExamSubquestionActive', 'poolId', poolId)
            // verify required parameter 'subquestionId' is not null or undefined
            assertParamExists('setPracticalExamSubquestionActive', 'subquestionId', subquestionId)
            // verify required parameter 'setPracticalExamSubquestionActiveRequestDto' is not null or undefined
            assertParamExists('setPracticalExamSubquestionActive', 'setPracticalExamSubquestionActiveRequestDto', setPracticalExamSubquestionActiveRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions/{subquestionId}/active`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"subquestionId"}}`, encodeURIComponent(String(subquestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPracticalExamSubquestionActiveRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Opis dla kandydata (zakres obszaru) widoczny dla zdającego w trakcie egzaminu.
         * @summary Update practical exam area (question) examinee description
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {UpdateExamineeDescriptionRequestDto} updateExamineeDescriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionExamineeDescription: async (poolId: number, questionId: number, updateExamineeDescriptionRequestDto: UpdateExamineeDescriptionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionExamineeDescription', 'poolId', poolId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionExamineeDescription', 'questionId', questionId)
            // verify required parameter 'updateExamineeDescriptionRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamQuestionExamineeDescription', 'updateExamineeDescriptionRequestDto', updateExamineeDescriptionRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/questions/{questionId}/examinee-description`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExamineeDescriptionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update practical exam question globalPass flag
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionGlobalPass: async (poolId: number, questionId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionGlobalPass', 'poolId', poolId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionGlobalPass', 'questionId', questionId)
            // verify required parameter 'globalPassUpdateRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamQuestionGlobalPass', 'globalPassUpdateRequestDto', globalPassUpdateRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/questions/{questionId}/global-pass`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalPassUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Czas przewidziany na zaliczenie obszaru w minutach (NULL = bez limitu).
         * @summary Update practical exam area (question) time limit in minutes
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionTimeLimit: async (poolId: number, questionId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionTimeLimit', 'poolId', poolId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updatePracticalExamQuestionTimeLimit', 'questionId', questionId)
            // verify required parameter 'timeLimitUpdateRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamQuestionTimeLimit', 'timeLimitUpdateRequestDto', timeLimitUpdateRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/questions/{questionId}/time-limit`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeLimitUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update practical exam report globalPass flag
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamReportGlobalPass: async (poolId: number, reportId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamReportGlobalPass', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updatePracticalExamReportGlobalPass', 'reportId', reportId)
            // verify required parameter 'globalPassUpdateRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamReportGlobalPass', 'globalPassUpdateRequestDto', globalPassUpdateRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}/global-pass`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalPassUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Czas przewidziany na zaliczenie obszaru \"Raporty\" w minutach (NULL = bez limitu).
         * @summary Update practical exam report (\"Raporty\" area) time limit in minutes
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamReportTimeLimit: async (poolId: number, reportId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamReportTimeLimit', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updatePracticalExamReportTimeLimit', 'reportId', reportId)
            // verify required parameter 'timeLimitUpdateRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamReportTimeLimit', 'timeLimitUpdateRequestDto', timeLimitUpdateRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}/time-limit`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeLimitUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamSubquestion: async (poolId: number, subquestionId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('updatePracticalExamSubquestion', 'poolId', poolId)
            // verify required parameter 'subquestionId' is not null or undefined
            assertParamExists('updatePracticalExamSubquestion', 'subquestionId', subquestionId)
            // verify required parameter 'upsertSubquestionRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamSubquestion', 'upsertSubquestionRequestDto', upsertSubquestionRequestDto)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions/{subquestionId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"subquestionId"}}`, encodeURIComponent(String(subquestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSubquestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Format: arkusz per obszar (np. \"OiW\", \"Pieczywo\", \"Lada\") z kolumnami Sekcja | Podkategoria | Punktowana (TAK/NIE). Arkusz \"Raporty\" z kolumnami Nazwa raportu | Sekcja | Podkategoria | Punktowana. Arkusz \"_Globalne zaliczenie\" z kolumnami Obszar | Globalne zaliczenie (TAK/NIE). Arkusze z prefiksem \"_\" są pomijane. Klucze odpowiedzi i pliki PDF NIE są w pliku — uzupełniane w UI po wgraniu. Jeśli wystąpią błędy walidacji, cały plik jest odrzucany i pula nie jest tworzona. 
         * @summary Upload new practical exam question pool from xlsx (format wielo-arkuszowy)
         * @param {File} file 
         * @param {number} [stageId] Optional stage ID to attach the created pool to
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewPracticalExamQuestionPool: async (file: File, stageId?: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadNewPracticalExamQuestionPool', 'file', file)
            const localVarPath = `/api/v2/practical-exam-question-pools/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (stageId !== undefined) {
                localVarQueryParameter['stageId'] = stageId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only application/pdf accepted. Max 10 MB.
         * @summary Upload a PDF attachment to a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPracticalExamReportAttachment: async (poolId: number, reportId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('uploadPracticalExamReportAttachment', 'poolId', poolId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('uploadPracticalExamReportAttachment', 'reportId', reportId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPracticalExamReportAttachment', 'file', file)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/reports/{reportId}/attachments`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wysłany plik (PDF / PNG / JPEG) jest przypisany do klucza dla 1 pkt albo 2 pkt (zależnie od `pointValue`). Max 10 MB. PDF i obrazy są renderowane inline w treści klucza w widoku komisji. 
         * @summary Upload an attachment (PDF/PNG/JPEG) to a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {File} file 
         * @param {UploadPracticalExamSubquestionAttachmentPointValueEnum} pointValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPracticalExamSubquestionAttachment: async (poolId: number, subquestionId: number, file: File, pointValue: UploadPracticalExamSubquestionAttachmentPointValueEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('uploadPracticalExamSubquestionAttachment', 'poolId', poolId)
            // verify required parameter 'subquestionId' is not null or undefined
            assertParamExists('uploadPracticalExamSubquestionAttachment', 'subquestionId', subquestionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPracticalExamSubquestionAttachment', 'file', file)
            // verify required parameter 'pointValue' is not null or undefined
            assertParamExists('uploadPracticalExamSubquestionAttachment', 'pointValue', pointValue)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/subquestions/{subquestionId}/attachments`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"subquestionId"}}`, encodeURIComponent(String(subquestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (pointValue !== undefined) { 
                localVarFormParams.append('pointValue', pointValue as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Append questions to existing practical exam pool
         * @param {number} poolId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadToExistingPracticalExamQuestionPool: async (poolId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('uploadToExistingPracticalExamQuestionPool', 'poolId', poolId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadToExistingPracticalExamQuestionPool', 'file', file)
            const localVarPath = `/api/v2/practical-exam-question-pools/{poolId}/upload`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamQuestionPoolApi - functional programming interface
 * @export
 */
export const PracticalExamQuestionPoolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamQuestionPoolApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Attach practical exam pool to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachPracticalExamPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachPracticalExamPoolToStage(certificationId, stageId, poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.attachPracticalExamPoolToStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dodaje nowy obszar (pytanie-obszar) do puli. Obszar pojawia się jako kolejna zakładka, do której można dodawać podkategorie (podpytania). 
         * @summary Create an area (question) in pool
         * @param {number} poolId 
         * @param {CreateAreaRequestDto} createAreaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPracticalExamArea(poolId: number, createAreaRequestDto: CreateAreaRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPracticalExamArea(poolId, createAreaRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.createPracticalExamArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dodaje podpytanie do pytania (obszaru). Opcjonalnie przypisuje do raportu (gdy subquestion jest pytaniem do raportu, nie do obszaru-pytania). 
         * @summary Create a subquestion in pool
         * @param {number} poolId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPracticalExamSubquestion(poolId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamSubquestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPracticalExamSubquestion(poolId, upsertSubquestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.createPracticalExamSubquestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a practical exam report (cascades to attachments + S3 objects)
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePracticalExamReport(poolId: number, reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePracticalExamReport(poolId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.deletePracticalExamReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a PDF attachment from a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePracticalExamReportAttachment(poolId: number, reportId: number, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePracticalExamReportAttachment(poolId, reportId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.deletePracticalExamReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a whole category (section) — all subquestions with the given area and sectionTitle
         * @param {number} poolId 
         * @param {string} area 
         * @param {string} sectionTitle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePracticalExamSection(poolId: number, area: string, sectionTitle: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePracticalExamSection(poolId, area, sectionTitle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.deletePracticalExamSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePracticalExamSubquestion(poolId: number, subquestionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePracticalExamSubquestion(poolId, subquestionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.deletePracticalExamSubquestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a PDF attachment from a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePracticalExamSubquestionAttachment(poolId: number, subquestionId: number, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePracticalExamSubquestionAttachment(poolId, subquestionId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.deletePracticalExamSubquestionAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detach practical exam pool from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachPracticalExamPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachPracticalExamPoolFromStage(certificationId, stageId, poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.detachPracticalExamPoolFromStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tworzy nową pulę pytań jako głęboką kopię istniejącej (questions, subquestions, reports, załączniki — same metadane, pliki S3 nie są kopiowane fizycznie; klonowane są same referencje). Wynikowa pula jest tworzona z `active=false` i pustym powiązaniem ze stage. 
         * @summary Duplicate an existing practical exam question pool
         * @param {number} poolId 
         * @param {DuplicatePoolRequestDto} duplicatePoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePracticalExamQuestionPool(poolId: number, duplicatePoolRequestDto: DuplicatePoolRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionPoolSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicatePracticalExamQuestionPool(poolId, duplicatePoolRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.duplicatePracticalExamQuestionPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practical exam pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionPoolDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamQuestionPoolDetail(poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.getPracticalExamQuestionPoolDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practical exam report detail with attachments
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamReportDetail(poolId: number, reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamReportItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamReportDetail(poolId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.getPracticalExamReportDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practical exam pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStagePracticalExamQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracticalExamQuestionPoolSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStagePracticalExamQuestionPools(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.getStagePracticalExamQuestionPools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List practical exam question pools
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ListPracticalExamQuestionPoolsSortByEnum} [sortBy] 
         * @param {ListPracticalExamQuestionPoolsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPracticalExamQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListPracticalExamQuestionPoolsSortByEnum, sortDirection?: ListPracticalExamQuestionPoolsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionPoolListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPracticalExamQuestionPools(page, pageSize, search, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.listPracticalExamQuestionPools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggles whether the pool is active. Inactive pools are excluded from question drawing for newly generated exams; existing exams keep their questions. 
         * @summary Set practical exam question pool active flag
         * @param {number} poolId 
         * @param {SetPracticalExamPoolActiveRequestDto} setPracticalExamPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPracticalExamQuestionPoolActive(poolId: number, setPracticalExamPoolActiveRequestDto: SetPracticalExamPoolActiveRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPracticalExamQuestionPoolActive(poolId, setPracticalExamPoolActiveRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.setPracticalExamQuestionPoolActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Przełącza flagę `active` podpytania (podkategorii). Nieaktywne podpytania nie są losowane do nowo generowanych egzaminów; istniejące wyniki egzaminów pozostają nietknięte. 
         * @summary Toggle subquestion active flag (soft delete / restore)
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {SetPracticalExamSubquestionActiveRequestDto} setPracticalExamSubquestionActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPracticalExamSubquestionActive(poolId: number, subquestionId: number, setPracticalExamSubquestionActiveRequestDto: SetPracticalExamSubquestionActiveRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamSubquestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPracticalExamSubquestionActive(poolId, subquestionId, setPracticalExamSubquestionActiveRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.setPracticalExamSubquestionActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Opis dla kandydata (zakres obszaru) widoczny dla zdającego w trakcie egzaminu.
         * @summary Update practical exam area (question) examinee description
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {UpdateExamineeDescriptionRequestDto} updateExamineeDescriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamQuestionExamineeDescription(poolId: number, questionId: number, updateExamineeDescriptionRequestDto: UpdateExamineeDescriptionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamQuestionExamineeDescription(poolId, questionId, updateExamineeDescriptionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamQuestionExamineeDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update practical exam question globalPass flag
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamQuestionGlobalPass(poolId: number, questionId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamQuestionGlobalPass(poolId, questionId, globalPassUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamQuestionGlobalPass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Czas przewidziany na zaliczenie obszaru w minutach (NULL = bez limitu).
         * @summary Update practical exam area (question) time limit in minutes
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamQuestionTimeLimit(poolId: number, questionId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamQuestionTimeLimit(poolId, questionId, timeLimitUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamQuestionTimeLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update practical exam report globalPass flag
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamReportGlobalPass(poolId: number, reportId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamReportGlobalPass(poolId, reportId, globalPassUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamReportGlobalPass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Czas przewidziany na zaliczenie obszaru \"Raporty\" w minutach (NULL = bez limitu).
         * @summary Update practical exam report (\"Raporty\" area) time limit in minutes
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamReportTimeLimit(poolId: number, reportId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamReportTimeLimit(poolId, reportId, timeLimitUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamReportTimeLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamSubquestion(poolId: number, subquestionId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamSubquestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamSubquestion(poolId, subquestionId, upsertSubquestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.updatePracticalExamSubquestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Format: arkusz per obszar (np. \"OiW\", \"Pieczywo\", \"Lada\") z kolumnami Sekcja | Podkategoria | Punktowana (TAK/NIE). Arkusz \"Raporty\" z kolumnami Nazwa raportu | Sekcja | Podkategoria | Punktowana. Arkusz \"_Globalne zaliczenie\" z kolumnami Obszar | Globalne zaliczenie (TAK/NIE). Arkusze z prefiksem \"_\" są pomijane. Klucze odpowiedzi i pliki PDF NIE są w pliku — uzupełniane w UI po wgraniu. Jeśli wystąpią błędy walidacji, cały plik jest odrzucany i pula nie jest tworzona. 
         * @summary Upload new practical exam question pool from xlsx (format wielo-arkuszowy)
         * @param {File} file 
         * @param {number} [stageId] Optional stage ID to attach the created pool to
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNewPracticalExamQuestionPool(file: File, stageId?: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionPoolUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNewPracticalExamQuestionPool(file, stageId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.uploadNewPracticalExamQuestionPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only application/pdf accepted. Max 10 MB.
         * @summary Upload a PDF attachment to a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPracticalExamReportAttachment(poolId: number, reportId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamReportAttachmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPracticalExamReportAttachment(poolId, reportId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.uploadPracticalExamReportAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wysłany plik (PDF / PNG / JPEG) jest przypisany do klucza dla 1 pkt albo 2 pkt (zależnie od `pointValue`). Max 10 MB. PDF i obrazy są renderowane inline w treści klucza w widoku komisji. 
         * @summary Upload an attachment (PDF/PNG/JPEG) to a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {File} file 
         * @param {UploadPracticalExamSubquestionAttachmentPointValueEnum} pointValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPracticalExamSubquestionAttachment(poolId: number, subquestionId: number, file: File, pointValue: UploadPracticalExamSubquestionAttachmentPointValueEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamSubquestionAttachmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPracticalExamSubquestionAttachment(poolId, subquestionId, file, pointValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.uploadPracticalExamSubquestionAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Append questions to existing practical exam pool
         * @param {number} poolId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadToExistingPracticalExamQuestionPool(poolId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamQuestionPoolUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadToExistingPracticalExamQuestionPool(poolId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamQuestionPoolApi.uploadToExistingPracticalExamQuestionPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamQuestionPoolApi - factory interface
 * @export
 */
export const PracticalExamQuestionPoolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamQuestionPoolApiFp(configuration)
    return {
        /**
         * 
         * @summary Attach practical exam pool to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPracticalExamPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.attachPracticalExamPoolToStage(certificationId, stageId, poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Dodaje nowy obszar (pytanie-obszar) do puli. Obszar pojawia się jako kolejna zakładka, do której można dodawać podkategorie (podpytania). 
         * @summary Create an area (question) in pool
         * @param {number} poolId 
         * @param {CreateAreaRequestDto} createAreaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamArea(poolId: number, createAreaRequestDto: CreateAreaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionItemDto> {
            return localVarFp.createPracticalExamArea(poolId, createAreaRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Dodaje podpytanie do pytania (obszaru). Opcjonalnie przypisuje do raportu (gdy subquestion jest pytaniem do raportu, nie do obszaru-pytania). 
         * @summary Create a subquestion in pool
         * @param {number} poolId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamSubquestion(poolId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto> {
            return localVarFp.createPracticalExamSubquestion(poolId, upsertSubquestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a practical exam report (cascades to attachments + S3 objects)
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamReport(poolId: number, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePracticalExamReport(poolId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a PDF attachment from a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamReportAttachment(poolId: number, reportId: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePracticalExamReportAttachment(poolId, reportId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a whole category (section) — all subquestions with the given area and sectionTitle
         * @param {number} poolId 
         * @param {string} area 
         * @param {string} sectionTitle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSection(poolId: number, area: string, sectionTitle: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePracticalExamSection(poolId, area, sectionTitle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSubquestion(poolId: number, subquestionId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePracticalExamSubquestion(poolId, subquestionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a PDF attachment from a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePracticalExamSubquestionAttachment(poolId: number, subquestionId: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePracticalExamSubquestionAttachment(poolId, subquestionId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detach practical exam pool from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPracticalExamPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.detachPracticalExamPoolFromStage(certificationId, stageId, poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Tworzy nową pulę pytań jako głęboką kopię istniejącej (questions, subquestions, reports, załączniki — same metadane, pliki S3 nie są kopiowane fizycznie; klonowane są same referencje). Wynikowa pula jest tworzona z `active=false` i pustym powiązaniem ze stage. 
         * @summary Duplicate an existing practical exam question pool
         * @param {number} poolId 
         * @param {DuplicatePoolRequestDto} duplicatePoolRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePracticalExamQuestionPool(poolId: number, duplicatePoolRequestDto: DuplicatePoolRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolSummaryDto> {
            return localVarFp.duplicatePracticalExamQuestionPool(poolId, duplicatePoolRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practical exam pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolDetailDto> {
            return localVarFp.getPracticalExamQuestionPoolDetail(poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practical exam report detail with attachments
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamReportDetail(poolId: number, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamReportItemDto> {
            return localVarFp.getPracticalExamReportDetail(poolId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practical exam pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStagePracticalExamQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticalExamQuestionPoolSummaryDto>> {
            return localVarFp.getStagePracticalExamQuestionPools(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List practical exam question pools
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ListPracticalExamQuestionPoolsSortByEnum} [sortBy] 
         * @param {ListPracticalExamQuestionPoolsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPracticalExamQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListPracticalExamQuestionPoolsSortByEnum, sortDirection?: ListPracticalExamQuestionPoolsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolListResponseDto> {
            return localVarFp.listPracticalExamQuestionPools(page, pageSize, search, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggles whether the pool is active. Inactive pools are excluded from question drawing for newly generated exams; existing exams keep their questions. 
         * @summary Set practical exam question pool active flag
         * @param {number} poolId 
         * @param {SetPracticalExamPoolActiveRequestDto} setPracticalExamPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPracticalExamQuestionPoolActive(poolId: number, setPracticalExamPoolActiveRequestDto: SetPracticalExamPoolActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPracticalExamQuestionPoolActive(poolId, setPracticalExamPoolActiveRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Przełącza flagę `active` podpytania (podkategorii). Nieaktywne podpytania nie są losowane do nowo generowanych egzaminów; istniejące wyniki egzaminów pozostają nietknięte. 
         * @summary Toggle subquestion active flag (soft delete / restore)
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {SetPracticalExamSubquestionActiveRequestDto} setPracticalExamSubquestionActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPracticalExamSubquestionActive(poolId: number, subquestionId: number, setPracticalExamSubquestionActiveRequestDto: SetPracticalExamSubquestionActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto> {
            return localVarFp.setPracticalExamSubquestionActive(poolId, subquestionId, setPracticalExamSubquestionActiveRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Opis dla kandydata (zakres obszaru) widoczny dla zdającego w trakcie egzaminu.
         * @summary Update practical exam area (question) examinee description
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {UpdateExamineeDescriptionRequestDto} updateExamineeDescriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionExamineeDescription(poolId: number, questionId: number, updateExamineeDescriptionRequestDto: UpdateExamineeDescriptionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamQuestionExamineeDescription(poolId, questionId, updateExamineeDescriptionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update practical exam question globalPass flag
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionGlobalPass(poolId: number, questionId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamQuestionGlobalPass(poolId, questionId, globalPassUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Czas przewidziany na zaliczenie obszaru w minutach (NULL = bez limitu).
         * @summary Update practical exam area (question) time limit in minutes
         * @param {number} poolId 
         * @param {number} questionId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamQuestionTimeLimit(poolId: number, questionId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamQuestionTimeLimit(poolId, questionId, timeLimitUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update practical exam report globalPass flag
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamReportGlobalPass(poolId: number, reportId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamReportGlobalPass(poolId, reportId, globalPassUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Czas przewidziany na zaliczenie obszaru \"Raporty\" w minutach (NULL = bez limitu).
         * @summary Update practical exam report (\"Raporty\" area) time limit in minutes
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamReportTimeLimit(poolId: number, reportId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamReportTimeLimit(poolId, reportId, timeLimitUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a subquestion
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamSubquestion(poolId: number, subquestionId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto> {
            return localVarFp.updatePracticalExamSubquestion(poolId, subquestionId, upsertSubquestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Format: arkusz per obszar (np. \"OiW\", \"Pieczywo\", \"Lada\") z kolumnami Sekcja | Podkategoria | Punktowana (TAK/NIE). Arkusz \"Raporty\" z kolumnami Nazwa raportu | Sekcja | Podkategoria | Punktowana. Arkusz \"_Globalne zaliczenie\" z kolumnami Obszar | Globalne zaliczenie (TAK/NIE). Arkusze z prefiksem \"_\" są pomijane. Klucze odpowiedzi i pliki PDF NIE są w pliku — uzupełniane w UI po wgraniu. Jeśli wystąpią błędy walidacji, cały plik jest odrzucany i pula nie jest tworzona. 
         * @summary Upload new practical exam question pool from xlsx (format wielo-arkuszowy)
         * @param {File} file 
         * @param {number} [stageId] Optional stage ID to attach the created pool to
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewPracticalExamQuestionPool(file: File, stageId?: number, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolUploadResultDto> {
            return localVarFp.uploadNewPracticalExamQuestionPool(file, stageId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Only application/pdf accepted. Max 10 MB.
         * @summary Upload a PDF attachment to a practical exam report
         * @param {number} poolId 
         * @param {number} reportId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPracticalExamReportAttachment(poolId: number, reportId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamReportAttachmentDto> {
            return localVarFp.uploadPracticalExamReportAttachment(poolId, reportId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Wysłany plik (PDF / PNG / JPEG) jest przypisany do klucza dla 1 pkt albo 2 pkt (zależnie od `pointValue`). Max 10 MB. PDF i obrazy są renderowane inline w treści klucza w widoku komisji. 
         * @summary Upload an attachment (PDF/PNG/JPEG) to a subquestion answer key
         * @param {number} poolId 
         * @param {number} subquestionId 
         * @param {File} file 
         * @param {UploadPracticalExamSubquestionAttachmentPointValueEnum} pointValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPracticalExamSubquestionAttachment(poolId: number, subquestionId: number, file: File, pointValue: UploadPracticalExamSubquestionAttachmentPointValueEnum, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionAttachmentDto> {
            return localVarFp.uploadPracticalExamSubquestionAttachment(poolId, subquestionId, file, pointValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Append questions to existing practical exam pool
         * @param {number} poolId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadToExistingPracticalExamQuestionPool(poolId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolUploadResultDto> {
            return localVarFp.uploadToExistingPracticalExamQuestionPool(poolId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamQuestionPoolApi - interface
 * @export
 * @interface PracticalExamQuestionPoolApi
 */
export interface PracticalExamQuestionPoolApiInterface {
    /**
     * 
     * @summary Attach practical exam pool to stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    attachPracticalExamPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Dodaje nowy obszar (pytanie-obszar) do puli. Obszar pojawia się jako kolejna zakładka, do której można dodawać podkategorie (podpytania). 
     * @summary Create an area (question) in pool
     * @param {number} poolId 
     * @param {CreateAreaRequestDto} createAreaRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    createPracticalExamArea(poolId: number, createAreaRequestDto: CreateAreaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionItemDto>;

    /**
     * Dodaje podpytanie do pytania (obszaru). Opcjonalnie przypisuje do raportu (gdy subquestion jest pytaniem do raportu, nie do obszaru-pytania). 
     * @summary Create a subquestion in pool
     * @param {number} poolId 
     * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    createPracticalExamSubquestion(poolId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto>;

    /**
     * 
     * @summary Delete a practical exam report (cascades to attachments + S3 objects)
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    deletePracticalExamReport(poolId: number, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a PDF attachment from a practical exam report
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    deletePracticalExamReportAttachment(poolId: number, reportId: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a whole category (section) — all subquestions with the given area and sectionTitle
     * @param {number} poolId 
     * @param {string} area 
     * @param {string} sectionTitle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    deletePracticalExamSection(poolId: number, area: string, sectionTitle: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a subquestion
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    deletePracticalExamSubquestion(poolId: number, subquestionId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a PDF attachment from a subquestion answer key
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    deletePracticalExamSubquestionAttachment(poolId: number, subquestionId: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Detach practical exam pool from stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    detachPracticalExamPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Tworzy nową pulę pytań jako głęboką kopię istniejącej (questions, subquestions, reports, załączniki — same metadane, pliki S3 nie są kopiowane fizycznie; klonowane są same referencje). Wynikowa pula jest tworzona z `active=false` i pustym powiązaniem ze stage. 
     * @summary Duplicate an existing practical exam question pool
     * @param {number} poolId 
     * @param {DuplicatePoolRequestDto} duplicatePoolRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    duplicatePracticalExamQuestionPool(poolId: number, duplicatePoolRequestDto: DuplicatePoolRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolSummaryDto>;

    /**
     * 
     * @summary Get practical exam pool detail with all questions
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    getPracticalExamQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolDetailDto>;

    /**
     * 
     * @summary Get practical exam report detail with attachments
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    getPracticalExamReportDetail(poolId: number, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamReportItemDto>;

    /**
     * 
     * @summary Get practical exam pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    getStagePracticalExamQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticalExamQuestionPoolSummaryDto>>;

    /**
     * 
     * @summary List practical exam question pools
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {ListPracticalExamQuestionPoolsSortByEnum} [sortBy] 
     * @param {ListPracticalExamQuestionPoolsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    listPracticalExamQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListPracticalExamQuestionPoolsSortByEnum, sortDirection?: ListPracticalExamQuestionPoolsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolListResponseDto>;

    /**
     * Toggles whether the pool is active. Inactive pools are excluded from question drawing for newly generated exams; existing exams keep their questions. 
     * @summary Set practical exam question pool active flag
     * @param {number} poolId 
     * @param {SetPracticalExamPoolActiveRequestDto} setPracticalExamPoolActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    setPracticalExamQuestionPoolActive(poolId: number, setPracticalExamPoolActiveRequestDto: SetPracticalExamPoolActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Przełącza flagę `active` podpytania (podkategorii). Nieaktywne podpytania nie są losowane do nowo generowanych egzaminów; istniejące wyniki egzaminów pozostają nietknięte. 
     * @summary Toggle subquestion active flag (soft delete / restore)
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {SetPracticalExamSubquestionActiveRequestDto} setPracticalExamSubquestionActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    setPracticalExamSubquestionActive(poolId: number, subquestionId: number, setPracticalExamSubquestionActiveRequestDto: SetPracticalExamSubquestionActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto>;

    /**
     * Opis dla kandydata (zakres obszaru) widoczny dla zdającego w trakcie egzaminu.
     * @summary Update practical exam area (question) examinee description
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {UpdateExamineeDescriptionRequestDto} updateExamineeDescriptionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamQuestionExamineeDescription(poolId: number, questionId: number, updateExamineeDescriptionRequestDto: UpdateExamineeDescriptionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update practical exam question globalPass flag
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamQuestionGlobalPass(poolId: number, questionId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Czas przewidziany na zaliczenie obszaru w minutach (NULL = bez limitu).
     * @summary Update practical exam area (question) time limit in minutes
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamQuestionTimeLimit(poolId: number, questionId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update practical exam report globalPass flag
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamReportGlobalPass(poolId: number, reportId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Czas przewidziany na zaliczenie obszaru \"Raporty\" w minutach (NULL = bez limitu).
     * @summary Update practical exam report (\"Raporty\" area) time limit in minutes
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamReportTimeLimit(poolId: number, reportId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a subquestion
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    updatePracticalExamSubquestion(poolId: number, subquestionId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionItemDto>;

    /**
     * Format: arkusz per obszar (np. \"OiW\", \"Pieczywo\", \"Lada\") z kolumnami Sekcja | Podkategoria | Punktowana (TAK/NIE). Arkusz \"Raporty\" z kolumnami Nazwa raportu | Sekcja | Podkategoria | Punktowana. Arkusz \"_Globalne zaliczenie\" z kolumnami Obszar | Globalne zaliczenie (TAK/NIE). Arkusze z prefiksem \"_\" są pomijane. Klucze odpowiedzi i pliki PDF NIE są w pliku — uzupełniane w UI po wgraniu. Jeśli wystąpią błędy walidacji, cały plik jest odrzucany i pula nie jest tworzona. 
     * @summary Upload new practical exam question pool from xlsx (format wielo-arkuszowy)
     * @param {File} file 
     * @param {number} [stageId] Optional stage ID to attach the created pool to
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    uploadNewPracticalExamQuestionPool(file: File, stageId?: number, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolUploadResultDto>;

    /**
     * Only application/pdf accepted. Max 10 MB.
     * @summary Upload a PDF attachment to a practical exam report
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    uploadPracticalExamReportAttachment(poolId: number, reportId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamReportAttachmentDto>;

    /**
     * Wysłany plik (PDF / PNG / JPEG) jest przypisany do klucza dla 1 pkt albo 2 pkt (zależnie od `pointValue`). Max 10 MB. PDF i obrazy są renderowane inline w treści klucza w widoku komisji. 
     * @summary Upload an attachment (PDF/PNG/JPEG) to a subquestion answer key
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {File} file 
     * @param {UploadPracticalExamSubquestionAttachmentPointValueEnum} pointValue 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    uploadPracticalExamSubquestionAttachment(poolId: number, subquestionId: number, file: File, pointValue: UploadPracticalExamSubquestionAttachmentPointValueEnum, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSubquestionAttachmentDto>;

    /**
     * 
     * @summary Append questions to existing practical exam pool
     * @param {number} poolId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApiInterface
     */
    uploadToExistingPracticalExamQuestionPool(poolId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamQuestionPoolUploadResultDto>;

}

/**
 * PracticalExamQuestionPoolApi - object-oriented interface
 * @export
 * @class PracticalExamQuestionPoolApi
 * @extends {BaseAPI}
 */
export class PracticalExamQuestionPoolApi extends BaseAPI implements PracticalExamQuestionPoolApiInterface {
    /**
     * 
     * @summary Attach practical exam pool to stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public attachPracticalExamPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).attachPracticalExamPoolToStage(certificationId, stageId, poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dodaje nowy obszar (pytanie-obszar) do puli. Obszar pojawia się jako kolejna zakładka, do której można dodawać podkategorie (podpytania). 
     * @summary Create an area (question) in pool
     * @param {number} poolId 
     * @param {CreateAreaRequestDto} createAreaRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public createPracticalExamArea(poolId: number, createAreaRequestDto: CreateAreaRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).createPracticalExamArea(poolId, createAreaRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dodaje podpytanie do pytania (obszaru). Opcjonalnie przypisuje do raportu (gdy subquestion jest pytaniem do raportu, nie do obszaru-pytania). 
     * @summary Create a subquestion in pool
     * @param {number} poolId 
     * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public createPracticalExamSubquestion(poolId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).createPracticalExamSubquestion(poolId, upsertSubquestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a practical exam report (cascades to attachments + S3 objects)
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public deletePracticalExamReport(poolId: number, reportId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).deletePracticalExamReport(poolId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a PDF attachment from a practical exam report
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public deletePracticalExamReportAttachment(poolId: number, reportId: number, attachmentId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).deletePracticalExamReportAttachment(poolId, reportId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a whole category (section) — all subquestions with the given area and sectionTitle
     * @param {number} poolId 
     * @param {string} area 
     * @param {string} sectionTitle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public deletePracticalExamSection(poolId: number, area: string, sectionTitle: string, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).deletePracticalExamSection(poolId, area, sectionTitle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a subquestion
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public deletePracticalExamSubquestion(poolId: number, subquestionId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).deletePracticalExamSubquestion(poolId, subquestionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a PDF attachment from a subquestion answer key
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public deletePracticalExamSubquestionAttachment(poolId: number, subquestionId: number, attachmentId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).deletePracticalExamSubquestionAttachment(poolId, subquestionId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detach practical exam pool from stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public detachPracticalExamPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).detachPracticalExamPoolFromStage(certificationId, stageId, poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tworzy nową pulę pytań jako głęboką kopię istniejącej (questions, subquestions, reports, załączniki — same metadane, pliki S3 nie są kopiowane fizycznie; klonowane są same referencje). Wynikowa pula jest tworzona z `active=false` i pustym powiązaniem ze stage. 
     * @summary Duplicate an existing practical exam question pool
     * @param {number} poolId 
     * @param {DuplicatePoolRequestDto} duplicatePoolRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public duplicatePracticalExamQuestionPool(poolId: number, duplicatePoolRequestDto: DuplicatePoolRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).duplicatePracticalExamQuestionPool(poolId, duplicatePoolRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practical exam pool detail with all questions
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public getPracticalExamQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).getPracticalExamQuestionPoolDetail(poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practical exam report detail with attachments
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public getPracticalExamReportDetail(poolId: number, reportId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).getPracticalExamReportDetail(poolId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practical exam pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public getStagePracticalExamQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).getStagePracticalExamQuestionPools(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List practical exam question pools
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {ListPracticalExamQuestionPoolsSortByEnum} [sortBy] 
     * @param {ListPracticalExamQuestionPoolsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public listPracticalExamQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListPracticalExamQuestionPoolsSortByEnum, sortDirection?: ListPracticalExamQuestionPoolsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).listPracticalExamQuestionPools(page, pageSize, search, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggles whether the pool is active. Inactive pools are excluded from question drawing for newly generated exams; existing exams keep their questions. 
     * @summary Set practical exam question pool active flag
     * @param {number} poolId 
     * @param {SetPracticalExamPoolActiveRequestDto} setPracticalExamPoolActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public setPracticalExamQuestionPoolActive(poolId: number, setPracticalExamPoolActiveRequestDto: SetPracticalExamPoolActiveRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).setPracticalExamQuestionPoolActive(poolId, setPracticalExamPoolActiveRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Przełącza flagę `active` podpytania (podkategorii). Nieaktywne podpytania nie są losowane do nowo generowanych egzaminów; istniejące wyniki egzaminów pozostają nietknięte. 
     * @summary Toggle subquestion active flag (soft delete / restore)
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {SetPracticalExamSubquestionActiveRequestDto} setPracticalExamSubquestionActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public setPracticalExamSubquestionActive(poolId: number, subquestionId: number, setPracticalExamSubquestionActiveRequestDto: SetPracticalExamSubquestionActiveRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).setPracticalExamSubquestionActive(poolId, subquestionId, setPracticalExamSubquestionActiveRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Opis dla kandydata (zakres obszaru) widoczny dla zdającego w trakcie egzaminu.
     * @summary Update practical exam area (question) examinee description
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {UpdateExamineeDescriptionRequestDto} updateExamineeDescriptionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamQuestionExamineeDescription(poolId: number, questionId: number, updateExamineeDescriptionRequestDto: UpdateExamineeDescriptionRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamQuestionExamineeDescription(poolId, questionId, updateExamineeDescriptionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update practical exam question globalPass flag
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamQuestionGlobalPass(poolId: number, questionId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamQuestionGlobalPass(poolId, questionId, globalPassUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Czas przewidziany na zaliczenie obszaru w minutach (NULL = bez limitu).
     * @summary Update practical exam area (question) time limit in minutes
     * @param {number} poolId 
     * @param {number} questionId 
     * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamQuestionTimeLimit(poolId: number, questionId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamQuestionTimeLimit(poolId, questionId, timeLimitUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update practical exam report globalPass flag
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {GlobalPassUpdateRequestDto} globalPassUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamReportGlobalPass(poolId: number, reportId: number, globalPassUpdateRequestDto: GlobalPassUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamReportGlobalPass(poolId, reportId, globalPassUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Czas przewidziany na zaliczenie obszaru \"Raporty\" w minutach (NULL = bez limitu).
     * @summary Update practical exam report (\"Raporty\" area) time limit in minutes
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {TimeLimitUpdateRequestDto} timeLimitUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamReportTimeLimit(poolId: number, reportId: number, timeLimitUpdateRequestDto: TimeLimitUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamReportTimeLimit(poolId, reportId, timeLimitUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a subquestion
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {UpsertSubquestionRequestDto} upsertSubquestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public updatePracticalExamSubquestion(poolId: number, subquestionId: number, upsertSubquestionRequestDto: UpsertSubquestionRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).updatePracticalExamSubquestion(poolId, subquestionId, upsertSubquestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Format: arkusz per obszar (np. \"OiW\", \"Pieczywo\", \"Lada\") z kolumnami Sekcja | Podkategoria | Punktowana (TAK/NIE). Arkusz \"Raporty\" z kolumnami Nazwa raportu | Sekcja | Podkategoria | Punktowana. Arkusz \"_Globalne zaliczenie\" z kolumnami Obszar | Globalne zaliczenie (TAK/NIE). Arkusze z prefiksem \"_\" są pomijane. Klucze odpowiedzi i pliki PDF NIE są w pliku — uzupełniane w UI po wgraniu. Jeśli wystąpią błędy walidacji, cały plik jest odrzucany i pula nie jest tworzona. 
     * @summary Upload new practical exam question pool from xlsx (format wielo-arkuszowy)
     * @param {File} file 
     * @param {number} [stageId] Optional stage ID to attach the created pool to
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public uploadNewPracticalExamQuestionPool(file: File, stageId?: number, name?: string, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).uploadNewPracticalExamQuestionPool(file, stageId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only application/pdf accepted. Max 10 MB.
     * @summary Upload a PDF attachment to a practical exam report
     * @param {number} poolId 
     * @param {number} reportId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public uploadPracticalExamReportAttachment(poolId: number, reportId: number, file: File, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).uploadPracticalExamReportAttachment(poolId, reportId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wysłany plik (PDF / PNG / JPEG) jest przypisany do klucza dla 1 pkt albo 2 pkt (zależnie od `pointValue`). Max 10 MB. PDF i obrazy są renderowane inline w treści klucza w widoku komisji. 
     * @summary Upload an attachment (PDF/PNG/JPEG) to a subquestion answer key
     * @param {number} poolId 
     * @param {number} subquestionId 
     * @param {File} file 
     * @param {UploadPracticalExamSubquestionAttachmentPointValueEnum} pointValue 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public uploadPracticalExamSubquestionAttachment(poolId: number, subquestionId: number, file: File, pointValue: UploadPracticalExamSubquestionAttachmentPointValueEnum, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).uploadPracticalExamSubquestionAttachment(poolId, subquestionId, file, pointValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Append questions to existing practical exam pool
     * @param {number} poolId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamQuestionPoolApi
     */
    public uploadToExistingPracticalExamQuestionPool(poolId: number, file: File, options?: RawAxiosRequestConfig) {
        return PracticalExamQuestionPoolApiFp(this.configuration).uploadToExistingPracticalExamQuestionPool(poolId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListPracticalExamQuestionPoolsSortByEnum = {
    Name: 'name',
    CreatedAt: 'createdAt'
} as const;
export type ListPracticalExamQuestionPoolsSortByEnum = typeof ListPracticalExamQuestionPoolsSortByEnum[keyof typeof ListPracticalExamQuestionPoolsSortByEnum];
/**
 * @export
 */
export const ListPracticalExamQuestionPoolsSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ListPracticalExamQuestionPoolsSortDirectionEnum = typeof ListPracticalExamQuestionPoolsSortDirectionEnum[keyof typeof ListPracticalExamQuestionPoolsSortDirectionEnum];
/**
 * @export
 */
export const UploadPracticalExamSubquestionAttachmentPointValueEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type UploadPracticalExamSubquestionAttachmentPointValueEnum = typeof UploadPracticalExamSubquestionAttachmentPointValueEnum[keyof typeof UploadPracticalExamSubquestionAttachmentPointValueEnum];
